import { gql } from "@apollo/client";
import {
  formatInteger,
  formatNumberWithMaxDecimals,
} from "../../services/common/NumberUtil";

export const GET_ATHLETES_SIMPLE = gql`
  query Query($filter: JSON, $offset: Int, $limit: Int, $sort: [[String]]) {
    athletes(filter: $filter, offset: $offset, limit: $limit, sort: $sort) {
      items {
        id
        lastname
        firstname
        category
        gender
        department
        scores
        club {
          id
          name
        }
      }
    }
  }
`;

export const QUERY_MY_ATHLETE_SUBSCRIPTION = gql`
  query Query($athlete_id: ID!) {
    my_athlete_subscription(athlete_id: $athlete_id) {
      id
    }
  }
`;
export const MUTATION_SUBSCRIBE_ATHLETE = gql`
  mutation Mutation($athlete_id: ID!) {
    subscribe_athlete(athlete_id: $athlete_id) {
      id
    }
  }
`;

export const MUTATION_UNSUBSCRIBE_ATHLETE = gql`
  mutation Mutation($athlete_id: ID!) {
    unsubscribe_athlete(athlete_id: $athlete_id)
  }
`;

export const MUTATION_ASSIGN_TO_ME = gql`
  mutation Mutation($athlete_id: ID!) {
    assign_athlete_to_me(athlete_id: $athlete_id) {
      id
      club_id
      athlete_id
    }
  }
`;

export const getAthleteQuery = ({
  club = false,
  last_result = false,
  actual_rankings = false,
}) => {
  return gql`
    query Query($id: ID!) {
      athlete(id: $id) {
        id
        firstname
        lastname
        scores
        license_number  
        category
        gender
        ${club ? "club { id name }" : ""}        
        ${
          last_result
            ? `last_result { id official_rank official_time competition_id   athlete_score_histories {old_score new_score type} competition { id name } }`
            : ""
        }
        ${
          actual_rankings
            ? "actual_rankings { id rank type category_rank gender_rank total total_category total_gender previous_ranking { id rank type category_rank gender_rank total total_category total_gender } }"
            : ""
        }
        club_id
     
        stats
      }
    }
  `;
};

export const formatAthleteScore = (athlete, scoreType = "general") => {
  let score = athlete.scores?.[scoreType];
  let count = athlete.scores?.[`${scoreType}_count`];
  if (score < 0 || !score || count === null) return "-";
  return `${formatNumberWithMaxDecimals(score, 2)}`;
};

export const formatAthleteRanking = (athleteRanking, field) => {
  if (!athleteRanking) {
    return "-";
  }
  let previousRanking = athleteRanking.previous_ranking;
  let totalField = "total";
  if (field === "category_rank") {
    totalField = "total_category";
  } else if (field === "gender_rank") {
    totalField = "total_gender";
  }
  let variation = "";
  if (previousRanking) {
    variation = previousRanking[field] - athleteRanking[field];
    let variationFormated = formatNumberWithMaxDecimals(variation, 0);

    variation = (
      <span
        className={` text-${variation > 0 ? "success" : "danger"}`}
        style={{ fontSize: "0.8em" }}
      >
        <i
          className={`ps-1 fa-solid fa-arrow-trend-${
            variation > 0 ? "up" : "down"
          }`}
        />{" "}
        {variationFormated}&nbsp;
      </span>
    );
  }

  return (
    <span>
      {formatInteger(athleteRanking[field])}
      {variation}/{formatInteger(athleteRanking[totalField])}
    </span>
  );
};
